import { Modal } from "@/components/General/Modal/modal";
import { propsAreValid } from "@/components/Modals/AddToCartModal/helpers/addToCartProps.helpers";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import {
    AddToCart,
    AddToCartProps
} from "./components/AddToCart/addToCart.container";

type AddToCartModalProps = {
    onClose?: () => void;
} & Omit<Partial<AddToCartProps>, "sku"> & { sku: string };

export const AddToCartModal = ({
    onClose,
    ...addToCartProps
}: AddToCartModalProps) => {
    const { isOpen, isActive, toggle } = useModalRouter(
        ModalType.AddToCart,
        addToCartProps.sku
    );

    const { t } = useGranite();

    const valid = propsAreValid(addToCartProps);

    const toggleHandler = (newState: boolean) => {
        if (!newState) {
            onClose?.();
        }

        toggle(newState);
    };

    const handleOnClose = () => toggleHandler(false);

    return (
        <Modal
            modalType={ModalType.AddToCart}
            descriminator={addToCartProps.sku}
            title={
                <h2
                    className="text-secondary"
                    style={{ wordBreak: "break-word" }}
                >
                    <i
                        className="las la-cart-arrow-down"
                        aria-hidden="true"
                    ></i>
                    {t("product.addtocart.modal.title")}
                </h2>
            }
            withFooter={false}
            open={isOpen && valid}
            active={isActive}
            setOpen={toggleHandler}
        >
            {valid && (
                <AddToCart
                    {...addToCartProps}
                    onClose={handleOnClose}
                />
            )}
        </Modal>
    );
};
